import {
	ALL_OPERATORS,
	REGULATION_OPERATORS,
	DOCUMENT_OPERATORS,
	getOperatorContact
} from 'helpers/operators';

export const NAV_LINKS = [
	{
		path: '/dokumenty',
		translation: 'user_profile_navigation_documents',
		operators: DOCUMENT_OPERATORS
	},
	{
		path: `/strona/regulamin`,
		translation: 'common_footer_terms_conditions',
		operators: REGULATION_OPERATORS
	},
	{
		path: `/strona/faq`,
		translation: 'common_footer_faq',
		operators: ALL_OPERATORS
	},
	{
		path: getOperatorContact(),
		translation: 'common_footer_contact',
		operators: ALL_OPERATORS
	}
];
